module.exports = __webpack_public_path__ + "img/default_course_image_2.0e2f811d.png";